import React from 'react'
import ContentLayout from '../../../../layout/contentLayout'
import WorktualSelect from '../../../../components/custom_components/WorktualSelect'
import { Link } from 'react-router-dom'
import styles from './scss/setupsmtp.module.scss';

const SetupSmtpEmail = () => {
     const selectOpt = [
        { value: 'one', label: 'One' }
    ]
    return (
        <ContentLayout noPaddingBlock={true}>
        <div className={styles.addemailaddresssec}>
            <div className='breadcrumbs'>
                <ol>
                    <li>
                        <Link to='/Email configuration '>Set Up SMTP Email</Link>
                    </li>
                    <li>Add Email Address</li>
                </ol>
            </div>
            <div className={styles.topheading}>
                <div className={styles.tophdlefts}>
                    <h2>Set Up SMTP Email</h2>
                    <p className={styles.headerdesctxt}>Configure your SMTP server to send and receive emails via Worktual.</p>
                </div>
            </div>
            <form className='formsec'>
                <div className='formrow'>
                    <div className='formlabels'>
                        <label htmlFor="">Ailas name</label>
                        <span className='formelemdesc'>Display name shown to recipients instead of the full email address.</span>
                    </div>
                    <div className='formelements'>
                       <input type="text" name="" id="" placeholder='e.g., Customer Support' />
                    </div>
                </div>
                <div className='formrow'>
                    <div className='formlabels'>
                        <label htmlFor="">Sender email</label>
                        <span className='formelemdesc'>The email address used to send outgoing messages.</span>
                    </div>
                    <div className='formelements'>
                        <input type="text" name="" id="" placeholder='e.g., support@yourdomain.com' />
                    </div>
                </div>
                <div className='formrow'>
                    <div className='formlabels'>
                        <label htmlFor="ailasname">User name</label>
                        <span className='formelemdesc'>Your SMTP account username (often the same as your sender email).</span>
                    </div>
                    <div className='formelements'>
                        <input type="text" name="" id="" placeholder='e.g., support@yourdomain.com' />
                    </div>
                </div>
                <div className='formrow'>
                    <div className='formlabels'>
                        <label htmlFor="ailasname">Password</label>
                        <span className='formelemdesc'>Password for your SMTP account.</span>
                    </div>
                    <div className='formelements'>
                        <div>
                            <input type="text" name="" id="" placeholder='Enter your SMTP password' />
                        </div>
                    </div>
                </div>
                <div className='formrow'>
                    <div className='formlabels'>
                        <label htmlFor="ailasname">Host</label>
                        <span className='formelemdesc'>SMTP server address (e.g., smtp.mailprovider.com).</span>
                    </div>
                    <div className='formelements'>
                        <div>
                            <input type="text" name="" id="" placeholder='e.g., smtp.yourprovider.com' />
                        </div>
                    </div>
                </div>
                <div className='formrow'>
                    <div className='formlabels'>
                        <label htmlFor="ailasname">Port</label>
                        <span className='formelemdesc'>SMTP server port (e.g., 465 for SSL, 587 for TLS).</span>
                    </div>
                    <div className='formelements'>
                        <input type="text" name="" id="" placeholder='e.g., 465' />
                    </div>
                </div>
                <div className='formrow'>
                    <div className='formlabels'>
                        <label htmlFor="ailasname">Bot assistance</label>
                    </div>
                    <div className='formelements'>
                        <div className={styles.botassist}>
                            <span className={styles.bttxt}>Enable the bot to send automated replies and follow-ups using this SMTP setup.</span>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    name="checkbox"
                                    onChange={() => { }}
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className='formbtns'>
                    <button className='cancelbtn'>Cancel</button><button className='primarybtn'>Next</button>
                </div>
            </form>
        </div>
        </ContentLayout>
    )
}

export default SetupSmtpEmail
